import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import classNames from 'classnames';
import Icon from '@xo-union/tk-component-icons';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import AnalyticsStore from '~/glm/models/analytics-store';
import styles from './download-list-button.scss';
import { downloadCSV, ADDRESSLABEL, RSVP, PEOPLE, exportTypes } from '~/glm/utils/download-export-csv';
import { ButtonDropdown, ButtonDropdownItem } from '../../button-dropdown';
import { Body1 } from '@xo-union/tk-ui-typography';

const DownloadListButton = ({ analyticsStore }) => {
  const triggerDownloadCSV = option => {
    downloadCSV(option);

    analyticsStore.track('Dashboard Interaction', {
      action: 'export',
      exportType: exportTypes[option],
    });
  };

  return (
    <ButtonDropdown
      className={classNames('cta', styles.addGuestButton)}
      color="secondary"
      size="lg"
      text="Download List"
    >
      <ButtonDropdownItem onClick={() => triggerDownloadCSV(PEOPLE)} data-testid="download-list-all">
        <div className={styles.dropdownItem}>
          <Icon className={styles.linkIcon} name="checklist" size="md" />
          <Body1>Entire Guest List</Body1>
          <div className={styles.subtext}>All guest info for all events</div>
        </div>
      </ButtonDropdownItem>
      <ButtonDropdownItem onClick={() => triggerDownloadCSV(ADDRESSLABEL)} data-testid="download-list-labels">
        <div className={styles.dropdownItem}>
          <Icon className={styles.linkIcon} name="email" size="md" />
          <Body1>Address Labels</Body1>
          <div className={styles.subtext}>Guest info formatted for envelopes</div>
        </div>
      </ButtonDropdownItem>
      <ButtonDropdownItem onClick={() => triggerDownloadCSV(RSVP)} data-testid="download-list-responses">
        <div className={styles.dropdownItem}>
          <Icon className={styles.linkIcon} name="quick_reply" size="md" />
          <Body1>RSVP Responses</Body1>
          <div className={styles.subtext}>All RSVP responses per guest</div>
        </div>
      </ButtonDropdownItem>
    </ButtonDropdown>
  );
};

DownloadListButton.propTypes = {
  gdsUiState: PropTypes.instanceOf(GdsUiState),
  analyticsStore: PropTypes.instanceOf(AnalyticsStore),
};

export default inject('analyticsStore')(observer(DownloadListButton));
